/** leads/config.ts — 기능 플래그
 * branchAssign: 지점 배정(선점제) UI 노출 여부.
 * 현재 운영은 FP 이름+휴대폰 개인 배정만 사용 — 지점 개념은 닫아둠.
 * 백엔드 라우트·DB 컬럼·선점 로직은 유지되어 있어 true로 바꾸면 즉시 복원됨.
 */
export const FEATURES = {
  branchAssign: false,
} as const;
